<template>
    <v-dialog :value="value" @input="$emit('input', $event)" max-width="400">
        <v-card>
            <v-card-title>Daftar: {{ title }}?</v-card-title>

            <v-card-actions>
                <v-spacer></v-spacer>

                <v-btn @click="$emit('input', false)" text>batal</v-btn>
                <v-btn
                    @click="enroll"
                    color="primary"
                    text
                    :loading="$store.get('loader/loading', 'enrollment')"
                >
                    daftar
                </v-btn>
            </v-card-actions>
        </v-card>
    </v-dialog>
</template>

<script>
export default {
    props: {
        value: {
            type: Boolean
        },

        period: {
            type: Object,
        }
    },

    computed: {
        title() {
            return this.period.title + (this.period.is_trial ? ' (Trial)' : '')
        }
    },

    methods: {
        enroll() {
            this.$api.post(`tryoutPeriod/${this.period.id}/enroll`, {}, { loader: 'enrollment' })
                .then(() => {
                    this.$tracking.event.program.register(this.period.title)
                    return this.$api.get('enrollment', { loader: 'enrollment' })
                })
                .then(response => {
                    this.$store.set('enrollment/enrollments', response.data.enrollments)

                    this.$store.dispatch('enrollment/selectByPeriodId', this.period.id)
                    localStorage.setItem('lastSelectedPeriodId', this.period.id)

                    this.$router.push({ name: 'payment' })
                })
        }
    }
}
</script>
